import { spiritoryWebApi } from '@/lib/axios/spiritoryWebApi';
import { BaseApiResponse } from '@/types/api/api-v2';

export default async function doGetFooterQrCode() {
  try {
    const {
      data: { data },
    } = await spiritoryWebApi.get<BaseApiResponse<string>>('/qr-code/footer');
    return data;
  } catch (err) {
    throw err;
  }
}
